var React = require('react');

function UpRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.61231 2.85204L5.62039 2.75275L1.71171 6.66142L2.33847 7.28818L6.24714 3.3795L6.14785 6.38758L7.08144 5.45399L7.17017 2.22038L6.77885 1.82907L3.5459 1.91845L2.61231 2.85204Z","fill":"#fffef8"}));
}

UpRight.defaultProps = {"viewBox":"0 0 9 9","fill":"none"};

module.exports = UpRight;

UpRight.default = UpRight;
